import { Injectable } from '@angular/core';

declare const google: any;

@Injectable({ providedIn: 'root' })
export class MapsAPILoader {
  private ready?: Promise<void>;

  load(): Promise<void> {
    if (this.ready) return this.ready;

    this.ready = new Promise<void>((resolve) => {
      if (typeof window !== 'undefined' && (window as any).google && (window as any).google.maps) {
        resolve();
        return;
      }
      const interval = setInterval(() => {
        if (typeof window !== 'undefined' && (window as any).google && (window as any).google.maps) {
          clearInterval(interval);
          resolve();
        }
      }, 100);
    });

    return this.ready;
  }
}
